import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class TitleReferenceService extends BaseReferenceService {
  constructor() {
    super('TitleReference');
  }
}
